module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_30_2-fa9d1e6f3a5d5e07d76e40f096fdb38c.svg";